// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiCreateNewWaveScope } from '../models/ApiCreateNewWaveScope';
import { ApiWaveDecisionsStrategy } from '../models/ApiWaveDecisionsStrategy';
import { ApiWaveType } from '../models/ApiWaveType';
import { HttpFile } from '../http/http';

export class ApiCreateWaveConfig {
    'type': ApiWaveType;
    /**
    * Single positive threshold a drop must reach to win. Must be set if and only if type is APPROVE
    */
    'winning_threshold': number | null;
    /**
    * Total number of APPROVE decisions this wave may produce. Null means unlimited. Must be set if and only if type is APPROVE
    */
    'max_winners': number | null;
    /**
    * Maximum absolute vote one identity can hold on a single drop. Null means unlimited. Supported only for APPROVE and RANK waves
    */
    'max_votes_per_identity_to_drop'?: number | null;
    /**
    * Vote of a voter is considered eligible after this amount of time after casting it. If not set then votes are eligible immediately after casting.
    */
    'time_lock_ms': number | null;
    'admin_group': ApiCreateNewWaveScope | null;
    'decisions_strategy': ApiWaveDecisionsStrategy | null;
    'admin_drop_deletion_enabled': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "type",
            "baseName": "type",
            "type": "ApiWaveType",
            "format": ""
        },
        {
            "name": "winning_threshold",
            "baseName": "winning_threshold",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "max_winners",
            "baseName": "max_winners",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "max_votes_per_identity_to_drop",
            "baseName": "max_votes_per_identity_to_drop",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "time_lock_ms",
            "baseName": "time_lock_ms",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "admin_group",
            "baseName": "admin_group",
            "type": "ApiCreateNewWaveScope",
            "format": ""
        },
        {
            "name": "decisions_strategy",
            "baseName": "decisions_strategy",
            "type": "ApiWaveDecisionsStrategy",
            "format": ""
        },
        {
            "name": "admin_drop_deletion_enabled",
            "baseName": "admin_drop_deletion_enabled",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCreateWaveConfig.attributeTypeMap;
    }

    public constructor() {
    }
}



